import { ThemeContext } from 'contexts/theme-context'
import * as React from 'react'

function FacebookIcon(props: React.SVGProps<SVGSVGElement>) {
  const { theme } = React.useContext(ThemeContext)

  return (
    <svg width={20} height={20} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10 0C4.477 0 0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.879V12.89h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.989C16.343 19.129 20 14.99 20 10c0-5.523-4.477-10-10-10z'
        fill={theme === 'dark' ? 'white' : '#636366'}
      />
    </svg>
  )
}

export default FacebookIcon
